import { PureComponent } from 'react'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
import EventsService from 'src/utils/events-service'

import { postRequest } from 'src/utils/request-client'
import {
  logError,
  getErrorMessage,
  setLoginToken,
  getBrandSettings,
  setChatIdentity,
  updateChatIdentity,
  isEmpty,
  getChatChannelName,
  setChatChannelName,
  updateChatChannelName,
  getParamFromUrl,
  getFeatures,
} from 'src/utils/helpers'
import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from '../translations'
import withToast from 'src/components/Toast'
/**
 * Currently not used for login through email, but IT IS used for "Login as Kiosk user" from Pathway side
 */
class EmailVerification extends PureComponent {
  componentDidMount() {
    const {
      intl,
      history,
      match,
      clearEmail,
      setSettings,
      resetUser,
      resetApp,
      setUser,
      isChatEmpty,
      setUserLastAccessType,
      toast,
      setFeatures,
    } = this.props

    const referer = getParamFromUrl(match.params, 'ref', 'logInTokenLink')
    // const redirectTo = getParamFromUrl(match.params, 'redirectTo', '/')

    const chatChannelName = getChatChannelName()
    postRequest(
      {
        base: '/tokens/login',
        mock: false,
      },
      {
        payload: getParamFromUrl(match.params, 'token', null),
        chatChannel:
          !isChatEmpty && chatChannelName.length ? encodeURIComponent(chatChannelName) : null,
        ref: referer,
      },
    )
      .then(response => {
        // NOTE: Do not used "async/await" because it caused this component (componentDidMount) to run multiple times

        const { token, user, chatVisitorIdentity, chatChannelUniqueName } = response

        if (!response || !token || isEmpty(user)) {
          history.push('/')
          return false
        }
        try {
          resetApp(referer)
          resetUser()
          clearEmail()
        } catch (e) {
          logError('Unable to reset app', e)
        }

        setLoginToken(token)

        try {
          setUser(user)

          setUserLastAccessType(referer)

          EventsService.registerEvent({ isWidget: false }, 'access', referer)
        } catch (e) {
          logError('Unable to update user from token', e)
        }

        try {
          // If user logging in has existing/older chat
          if (chatVisitorIdentity && chatChannelUniqueName /* && isChatEmpty === true*/) {
            // Set existing/older chat channel name
            setChatChannelName(chatChannelUniqueName, user, isChatEmpty)

            // Set existing/older chat identity
            // We need to set this even thought we're not updating it in database or on twilio side,
            // but it needs to match the channel we're loading
            setChatIdentity(chatVisitorIdentity, user, isChatEmpty)
          } else {
            // Update existing chat channel name and identity (to become unlimited - cookie not expiring)
            updateChatChannelName(user, isChatEmpty)
            updateChatIdentity(user, isChatEmpty)
          }
        } catch (e) {
          logError('Unable to update chat identity after login from token', e, 0)
        }

        // NOTE: Using "await" caused this component (componentDidMount) to run multiple times
        // There were also some async related errors (for setSettings) when token expired and needed to be renewed,
        // so this might fail sometimes but we need to catch it all
        try {
          getBrandSettings('a').then(settings => {
            try {
              setSettings(settings)
            } catch (e) {
              logError('Error settings new settings after login from token', e, 0)
            }
          })
        } catch (e) {
          logError('Unable to fetch settings after login from token', e, 0)
        }

        try {
          getFeatures().then(features => {
            try {
              setFeatures(features)
            } catch (e) {
              logError('Error fetch features')
            }
          })
        } catch (e) {
          logError('Unable to fetch features after login from token', e, 0)
        }

        // TODO: PAT-2713 Figure out how to redirect to specific page (redirectTo),
        //  because redirecting to anything other than '/' - can invalidate new token
        history.push('/')
      })
      .catch(e => {
        toast({
          title: intl.formatMessage(intlMessagesApp.appErrorTitle),
          description: getErrorMessage(
            e,
            intl.formatMessage(intlMessages.authLoginNotificationUnableToLoginToken),
          ),
          status: 'warning',
        })

        history.push('/')
      })
  }

  render() {
    return null
  }
}

export default withRouter(injectIntl(withToast(EmailVerification)))
